module.exports = __webpack_public_path__ + "img/showmorw06.62bb753.png";